import { IconName } from '@optimus-web/icons';
import { Stack } from '../Stack';
import { Typography, TypographyOptions } from '../typography';
import { BannerCloseButton, BannerElement, BannerIconElement, LinkContainer } from './style';
import { BannerVariant } from './types';

const DEFAULT_ICONS: Record<BannerVariant, IconName> = {
    info: IconName.Info,
    success: IconName.CheckCircle,
    warning: IconName.Problematic,
    error: IconName.AlertCircle,
};

export type BannerProps = {
    variant: BannerVariant;
    centered?: boolean;
    onClose?: (event: React.MouseEvent<HTMLElement>) => void;
    action?: React.ReactNode;
    wordBreak?: TypographyOptions['wordBreak'];
} & (
    | { primaryText: React.ReactNode; secondaryText?: React.ReactNode }
    | { primaryText?: React.ReactNode; secondaryText: React.ReactNode }
);

const Banner = ({
    primaryText,
    variant = 'info',
    centered,
    onClose,
    action,
    secondaryText,
    wordBreak,
    ...other
}: BannerProps) => (
    <BannerElement variant={variant} {...other}>
        <BannerIconElement value={DEFAULT_ICONS[variant]} />
        <Stack vertical fill spacing="50">
            {primaryText ? (
                <Typography
                    textStyle="bodyMediumStrong"
                    wordBreak={wordBreak}
                    align={centered ? 'center' : 'left'}
                    as="div"
                >
                    {primaryText}
                </Typography>
            ) : null}
            {secondaryText ? (
                <Typography textStyle="bodyMedium" as="div" wordBreak={wordBreak} align={centered ? 'center' : 'left'}>
                    {secondaryText}
                </Typography>
            ) : null}
            {action ? (
                <LinkContainer padding={['100', '0', '0']} align={centered ? 'center' : 'left'}>
                    {action}
                </LinkContainer>
            ) : null}
        </Stack>
        {onClose ? (
            <Stack itemAlignment={!secondaryText && !action ? 'center' : 'start'}>
                <BannerCloseButton onClick={onClose} size="small" icon={IconName.CrossClose} />
            </Stack>
        ) : null}
    </BannerElement>
);

export default Banner;
